/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetPharmacyInfoErrorResponse, GetPharmacyInfoResponse } from './api.schemas';

import { api } from '../util/http';

export const getPharmacyById = (pharmacyId: number, signal?: AbortSignal) => {
  return api<GetPharmacyInfoResponse>({
    url: `/api/pharmacies/${pharmacyId}`,
    method: 'GET',
    signal,
  });
};

export const getGetPharmacyByIdQueryKey = (pharmacyId?: number) => {
  return [`/api/pharmacies/${pharmacyId}`] as const;
};

export const getGetPharmacyByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPharmacyById>>,
  TError = GetPharmacyInfoErrorResponse,
>(
  pharmacyId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacyById>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPharmacyByIdQueryKey(pharmacyId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPharmacyById>>> = ({ signal }) =>
    getPharmacyById(pharmacyId, signal);

  return { queryKey, queryFn, enabled: !!pharmacyId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPharmacyById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPharmacyByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPharmacyById>>>;
export type GetPharmacyByIdQueryError = GetPharmacyInfoErrorResponse;

export function useGetPharmacyById<
  TData = Awaited<ReturnType<typeof getPharmacyById>>,
  TError = GetPharmacyInfoErrorResponse,
>(
  pharmacyId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacyById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharmacyById>>,
          TError,
          Awaited<ReturnType<typeof getPharmacyById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPharmacyById<
  TData = Awaited<ReturnType<typeof getPharmacyById>>,
  TError = GetPharmacyInfoErrorResponse,
>(
  pharmacyId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacyById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharmacyById>>,
          TError,
          Awaited<ReturnType<typeof getPharmacyById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPharmacyById<
  TData = Awaited<ReturnType<typeof getPharmacyById>>,
  TError = GetPharmacyInfoErrorResponse,
>(
  pharmacyId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacyById>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPharmacyById<
  TData = Awaited<ReturnType<typeof getPharmacyById>>,
  TError = GetPharmacyInfoErrorResponse,
>(
  pharmacyId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacyById>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPharmacyByIdQueryOptions(pharmacyId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
